"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = exports.Footer = exports.Body = exports.Title = exports.Header = exports.Content = exports.Overlay = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _designTokens = require("@decisiv/design-tokens");

var _dynamicModifiers = require("../../utils/dynamicModifiers");

var _Button = _interopRequireDefault(require("../Button"));

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Overlay = _styledComponents.default.div.withConfig({
  displayName: "styles__Overlay",
  componentId: "p3l2i8-0"
})(["display:", ";position:fixed;background:", ";bottom:0;left:0;right:0;top:0;justify-content:", ";", ";"], function (_ref) {
  var visible = _ref.visible;
  return visible ? 'flex' : 'none';
}, (0, _toColorString.default)(_designTokens.color.opacity.charcoal75), function (_ref2) {
  var side = _ref2.side;
  return side === 'left' ? 'start' : 'end';
}, (0, _dynamicModifiers.applyDynamicModifiers)('zIndex', 'z-index'));

exports.Overlay = Overlay;
var DRAWER_WIDTH = (0, _rem.default)(_designTokens.spacing.base * 40);

var Content = _styledComponents.default.div.withConfig({
  displayName: "styles__Content",
  componentId: "p3l2i8-1"
})(["position:relative;height:100%;width:", ";top:0;display:flex;flex-direction:column;background-color:", ";animation-duration:0.75s;@keyframes fadeinleft{from{left:-", ";}to{left:0;}}@keyframes fadeinright{from{right:-", ";}to{right:0;}}", ""], DRAWER_WIDTH, (0, _toColorString.default)(_designTokens.color.base.snowWhite), DRAWER_WIDTH, DRAWER_WIDTH, function (_ref3) {
  var side = _ref3.side;
  return side === 'left' ? (0, _styledComponents.css)(["animation-name:fadeinleft;"]) : (0, _styledComponents.css)(["animation-name:fadeinright;"]);
});

exports.Content = Content;

var Header = _styledComponents.default.div.withConfig({
  displayName: "styles__Header",
  componentId: "p3l2i8-2"
})(["display:flex;flex-direction:column;padding:", ";min-height:fit-content;background-color:", ";"], (0, _rem.default)(_designTokens.spacing.base * 2), (0, _toColorString.default)(_designTokens.color.base.snowWhite));

exports.Header = Header;
var Title = (0, _styledComponents.default)(_Typography.H3).withConfig({
  displayName: "styles__Title",
  componentId: "p3l2i8-3"
})(["word-break:break-word;"]);
exports.Title = Title;

var Body = _styledComponents.default.div.withConfig({
  displayName: "styles__Body",
  componentId: "p3l2i8-4"
})(["display:flex;height:100%;overflow-y:auto;background-color:", ";"], (0, _toColorString.default)(_designTokens.color.base.snowWhite));

exports.Body = Body;

var Footer = _styledComponents.default.div.withConfig({
  displayName: "styles__Footer",
  componentId: "p3l2i8-5"
})(["height:", ";display:flex;padding:", " ", ";margin-top:auto;background-color:", ";border-top:1px solid ", ";"], (0, _rem.default)(_designTokens.spacing.base * 6.2), (0, _rem.default)(_designTokens.spacing.base * 1.5), (0, _rem.default)(_designTokens.spacing.base * 2), (0, _toColorString.default)(_designTokens.color.base.fullMoon), (0, _toColorString.default)(_designTokens.color.opacity.charcoal15));

exports.Footer = Footer;
var CloseButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "styles__CloseButton",
  componentId: "p3l2i8-6"
})(["padding-right:0;padding-left:", ";margin-left:auto;"], (0, _rem.default)(_designTokens.spacing.base));
exports.CloseButton = CloseButton;